import React from 'react';
import { LandingPageContent } from './components/landing-page-content/landing-page-content';
import ResourcesPage from '../resources/resources';
import { useNativeHeader } from './hooks/use-native-header.hook';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const LandingPage = (): JSX.Element => {
  useNativeHeader();
  const { resourceBookingSkipLandingPage } = useFlags();

  return resourceBookingSkipLandingPage ? <ResourcesPage /> : <LandingPageContent />;
};
